function kwSyncYear(input){
 const value=input.value.trim(),last=new Date().getFullYear()+1;
 input.setCustomValidity(value&&(!/^\d{4}$/.test(value)||Number(value)<1886||Number(value)>last)?'Enter a model year from 1886 to '+last+'.':'');
}
document.querySelectorAll('[data-kw-year]').forEach(kwSyncYear);
document.addEventListener('input',event=>{if(event.target.matches('[data-kw-year]'))kwSyncYear(event.target);});
document.addEventListener('change',event=>{if(event.target.matches('[data-kw-year]'))kwSyncYear(event.target);});
const kwPreparedPhotos=new WeakMap();
function kwIsHeic(file){return /^image\/(heic|heif)(-sequence)?$/i.test(file.type)||/\.hei[cf]$/i.test(file.name);}
function kwPhotoAllowed(file){return ['image/jpeg','image/png','image/webp'].includes(file.type)||kwIsHeic(file)||(!file.type&&/\.(jpe?g|png|webp)$/i.test(file.name));}
async function kwPreparePhoto(file){
 const heic=kwIsHeic(file);
 const url=URL.createObjectURL(file),image=new Image();
 try{
  image.src=url;
  await image.decode();
  if(!image.naturalWidth||!image.naturalHeight)throw new Error('Image has no dimensions');
  if(!heic&&file.size<=2*1024*1024)return file;
  const scale=Math.min(1,3000/Math.max(image.naturalWidth,image.naturalHeight));
  const canvas=document.createElement('canvas');
  canvas.width=Math.max(1,Math.round(image.naturalWidth*scale));
  canvas.height=Math.max(1,Math.round(image.naturalHeight*scale));
  const context=canvas.getContext('2d');
  if(!context)throw new Error('Image processing unavailable');
  context.fillStyle='#fff';context.fillRect(0,0,canvas.width,canvas.height);
  context.drawImage(image,0,0,canvas.width,canvas.height);
  const encode=quality=>new Promise((resolve,reject)=>canvas.toBlob(blob=>blob?resolve(blob):reject(new Error('Image processing failed')),'image/jpeg',quality));
  let blob=await encode(.92);
  if(blob.size>5*1024*1024)blob=await encode(.86);
  if(blob.size>5*1024*1024)throw new Error('Image remains too large');
  if(!heic&&blob.size>=file.size&&file.size<=5*1024*1024)return file;
  return new File([blob],file.name.replace(/\.[^.]+$/,'')+'.jpg',{type:'image/jpeg',lastModified:file.lastModified});
 }finally{URL.revokeObjectURL(url);}
}
document.addEventListener('change',async event=>{
 if(!event.target.matches('[data-kw-photo]'))return;
 const input=event.target,file=input.files[0],fieldset=input.closest('fieldset');
 const preview=fieldset.querySelector('.kw-photo-preview'),status=fieldset.querySelector('[data-kw-photo-status]');
 const job={file,prepared:null};kwPreparedPhotos.set(input,job);
 input.setCustomValidity('');
 if(preview.dataset.objectUrl)URL.revokeObjectURL(preview.dataset.objectUrl);
 preview.removeAttribute('src');preview.hidden=true;
 if(status){status.textContent='';status.hidden=true;}
 if(!file)return;
 const message=key=>input.dataset[key];
 const report=text=>{input.setCustomValidity(kwOptionalForm(input.closest('form'))?'':text);if(status){status.textContent=text;status.hidden=false;}};
 if(!kwPhotoAllowed(file)||file.size>30*1024*1024){report(message('photoInvalid'));input.reportValidity();return;}
 report(message('photoPreparing'));
 try{
  const prepared=await kwPreparePhoto(file);
  if(kwPreparedPhotos.get(input)!==job)return;
  job.prepared=prepared;input.setCustomValidity('');
  const url=URL.createObjectURL(prepared);preview.dataset.objectUrl=url;preview.src=url;preview.hidden=false;
  if(status){status.textContent=message(prepared===file?'photoReady':'photoOptimized');status.hidden=false;}
  kwSyncOptional(input.closest('form'));
 }catch{
  if(kwPreparedPhotos.get(input)!==job)return;
  report(message(kwIsHeic(file)?'photoHeicFailed':'photoFailed'));input.reportValidity();
 }
});
document.addEventListener('click',event=>{const button=event.target.closest('[data-kw-review]');if(!button)return;const form=button.closest('form');if(!form.reportValidity())return;const box=form.parentElement.querySelector('.kw-review'),list=box.querySelector('dl');list.replaceChildren();for(const [key,value]of new FormData(form)){if(!key.startsWith('properties[')||!value)continue;const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=key.slice(11,-1);dd.textContent=value instanceof File?value.name:String(value);list.append(dt,dd);}box.hidden=false;box.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});});document.addEventListener('submit',event=>{if(event.target.id==='kw-preview-form')event.preventDefault();});
function kwUpdateBrand(select){const field=select.closest('fieldset').querySelector('[data-kw-other-brand]');if(!field)return;const other=select.value==='Other';field.hidden=!other;const input=field.querySelector('input');input.disabled=!other;input.required=other;}document.querySelectorAll('[data-kw-brand]').forEach(kwUpdateBrand);document.addEventListener('change',event=>{if(event.target.matches('[data-kw-brand]'))kwUpdateBrand(event.target);});document.addEventListener('input',event=>{const form=event.target.closest('.kw-form');if(form){const review=form.parentElement.querySelector('.kw-review');if(review)review.hidden=true;}});document.addEventListener('click',event=>{if(event.target.closest('[data-kw-edit]')){const form=event.target.closest('.kw-product-info').querySelector('form');form.querySelector('select,input:not([type=hidden])').focus();form.scrollIntoView({behavior:'smooth',block:'start'});}const link=event.target.closest('[data-kw-inquire]');if(link){const form=link.closest('.kw-product-info').querySelector('form');const details=[];for(const[key,value]of new FormData(form)){if(key.startsWith('properties[')&&!(value instanceof File)&&value&&key!=='properties[Design Proof Acknowledgment]')details.push(key.slice(11,-1)+': '+value);}try{sessionStorage.setItem('kilnward-inquiry','I would like to discuss a custom pet emblem.\n\n'+details.join('\n')+'\n\nMy question: ');}catch{}}if(event.target.closest('[data-kw-menu] a'))event.target.closest('[data-kw-menu]').open=false;});const inquiry=document.querySelector('[data-kw-inquiry-body]');if(inquiry){try{const draft=sessionStorage.getItem('kilnward-inquiry');if(draft){inquiry.value=draft;sessionStorage.removeItem('kilnward-inquiry');}}catch{}}document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('[data-kw-menu][open]').forEach(menu=>menu.open=false);});document.querySelectorAll('[data-kw-faq]').forEach(container=>{const children=[...container.children];let details;for(const child of children){if(child.tagName==='H2'){details=document.createElement('details');const summary=document.createElement('summary');summary.textContent=child.textContent;details.append(summary);container.insertBefore(details,child);child.remove();}else if(details)details.append(child);}});

function kwSyncPalette(palette){
 const choices=[...palette.querySelectorAll('[data-kw-color]')];
 if(!choices.length)return;
 choices.forEach(input=>input.setCustomValidity(''));
 const limit=Number(palette.dataset.kwMaxColors);
 if(limit>0){
  const selected=choices.filter(input=>input.checked);
  choices.forEach(input=>{input.disabled=!input.checked&&selected.length>=limit;});
  if(selected.length>limit)selected[0].setCustomValidity('Choose up to '+limit+' colors.');
 }
 const custom=palette.querySelector('[data-kw-custom-color]');
 const field=palette.querySelector('[data-kw-custom-color-field]');
 if(!custom||!field)return;
 const input=field.querySelector('input');
 field.hidden=!custom.checked;input.disabled=!custom.checked;input.required=false;
}
function kwInitPalettes(root){root.querySelectorAll('[data-kw-palette]').forEach(kwSyncPalette);}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>kwInitPalettes(document));}else{kwInitPalettes(document);}
document.addEventListener('shopify:section:load',event=>kwInitPalettes(event.target));
window.addEventListener('pageshow',()=>kwInitPalettes(document));
document.addEventListener('change',event=>{
 const palette=event.target.closest('[data-kw-palette]');
 if(!palette)return;
 kwSyncPalette(palette);
 const form=palette.closest('form');
 const review=form?.parentElement.querySelector('.kw-review');
 if(review)review.hidden=true;
});
document.addEventListener('click',event=>{
 const action=event.target.closest('[data-kw-review], [data-kw-inquire]');
 if(!action)return;
 const form=action.closest('.kw-product-info')?.querySelector('.kw-form');
 if(!form)return;
 kwSyncOptional(form);
 kwInitPalettes(form);
 form.querySelectorAll('[data-kw-year]').forEach(kwSyncYear);
 if(!form.reportValidity()){event.preventDefault();event.stopImmediatePropagation();}
},true);
document.addEventListener('submit',event=>{
 const form=event.target;
 if(!form.matches('.kw-form'))return;
 kwSyncOptional(form);
 kwInitPalettes(form);
 form.querySelectorAll('[data-kw-year]').forEach(kwSyncYear);
 if(!form.reportValidity()){event.preventDefault();event.stopImmediatePropagation();}
},true);

document.addEventListener('change',event=>{if(!event.target.matches('[data-kw-photo]'))return;const label=event.target.closest('.kw-file-picker')?.querySelector('[data-kw-file-name]');if(label)label.textContent=event.target.files[0]?.name||'No photo selected';});

document.addEventListener('submit',event=>{
 const form=event.target;
 if(!form.matches('#kw-product-form')||event.defaultPrevented)return;
 const button=form.querySelector('[data-kw-add]'),box=form.querySelector('[data-kw-cart-feedback]');
 if(!button||!box)return;
 event.preventDefault();
 if(form.dataset.kwCartState)return;
 if(!form.reportValidity())return;
 const data=new FormData(form),status=box.querySelector('[data-kw-cart-status]'),next=box.querySelector('[data-kw-cart-next]');
 for(const input of form.querySelectorAll('[data-kw-photo]')){
  const job=kwPreparedPhotos.get(input);
  if(!input.disabled&&job?.file===input.files[0]&&job?.prepared)data.set(input.name,job.prepared,job.prepared.name);
 }
 const original=button.textContent,fields=[...form.querySelectorAll('fieldset:not(:disabled)')];
 const hasPhoto=[...data.values()].some(value=>value instanceof File&&value.size>0);
 form.dataset.kwCartState='pending';form.setAttribute('aria-busy','true');button.disabled=true;
 fields.forEach(field=>field.disabled=true);box.hidden=false;next.hidden=true;
 button.textContent=box.dataset.adding;status.textContent=hasPhoto?box.dataset.uploading:box.dataset.adding;
 const request=new XMLHttpRequest();
 request.open('POST',new URL(form.action,location.href).pathname.replace(/\/$/,'')+'.js');
 request.setRequestHeader('Accept','application/json');
 request.upload.addEventListener('progress',progress=>{
  if(!progress.lengthComputable||!hasPhoto)return;
  const percent=Math.min(100,Math.round(progress.loaded/progress.total*100));
  status.textContent=percent<100?box.dataset.uploading+' '+percent+'%':box.dataset.processing;
 });
 const release=()=>{fields.forEach(field=>field.disabled=false);form.removeAttribute('aria-busy');};
 const uncertain=()=>{release();form.dataset.kwCartState='uncertain';status.textContent=box.dataset.uncertain;button.textContent=original;next.hidden=false;next.querySelector('.kw-text-link').hidden=true;};
 request.addEventListener('error',uncertain);
 request.addEventListener('load',()=>{
  release();let result;
  try{result=JSON.parse(request.responseText);}catch{uncertain();return;}
  if(request.status>=200&&request.status<300&&(result.id||result.items?.length)){
   form.dataset.kwCartState='added';button.textContent=box.dataset.added;status.textContent=box.dataset.added;
   if(window.kwCartDrawer){next.hidden=false;window.kwCartDrawer.open({added:true,trigger:button}).catch(()=>{}).finally(()=>{delete form.dataset.kwCartState;button.disabled=false;button.textContent=original;});}else{location.assign(next.querySelector('a').href);}
  }else if(request.status>=400&&request.status<500){
   delete form.dataset.kwCartState;button.disabled=false;button.textContent=original;status.textContent=typeof result.description==='string'?result.description:box.dataset.error;
  }else{uncertain();}
 });
 request.send(data);
},true);

function kwOptionalForm(form){return !!form?.querySelector('[data-kw-photo-method]');}
function kwSyncOptional(form){
 if(!kwOptionalForm(form))return;
 const now=form.querySelector('[data-kw-photo-method]:checked')?.value==='Upload Now';
 const input=form.querySelector('[data-kw-photo]');
 form.querySelector('[data-kw-upload-area]').hidden=!now;
 input.disabled=!now;
 input.setCustomValidity('');
 const job=kwPreparedPhotos.get(input);
 const ready=now&&input.files[0]&&job?.file===input.files[0]&&!!job.prepared;
 form.querySelector('[data-kw-photo-state]').value=ready?'Photo provided':'Pending - Send Later';
 const order=kwOrderProperties(kwReadFormProperties(form));
 form.querySelector('[data-kw-missing]').value=order['_Details to Collect'];
 form.querySelector('[data-kw-details-status]').value=order['_Customization Status'];
 form.querySelector('[name="properties[_Color Preferences Status]"]').value=order['_Color Preferences Status'];
 const note=form.querySelector('[data-kw-photo-later-note]');
 note.textContent=ready?note.dataset.ready:now?note.dataset.nowPending:note.dataset.later;
 form.querySelector('[data-kw-photo-public]').value=ready?'Uploaded':'Send Later';
}
document.addEventListener('change',event=>{const form=event.target.closest('.kw-form');if(kwOptionalForm(form))kwSyncOptional(form);});
document.addEventListener('formdata',event=>{
 const form=event.target;if(!kwOptionalForm(form))return;
 kwSyncOptional(form);
 const data=event.formData,input=form.querySelector('[data-kw-photo]'),job=kwPreparedPhotos.get(input);
 const now=form.querySelector('[data-kw-photo-method]:checked')?.value==='Upload Now';
 const ready=now&&input.files[0]&&job?.file===input.files[0]&&!!job.prepared;
 if(ready)data.set(input.name,job.prepared,job.prepared.name);else data.delete(input.name);
 for(const field of form.querySelectorAll('[data-kw-photo-state],[data-kw-missing],[data-kw-photo-public]'))data.set(field.name,field.value);
 if(ready)data.delete('properties[Pet photo]');else data.set('properties[Pet photo]','Send Later');
 data.set('properties[_Photo Submission]',ready?'Uploaded':'Send Later');
});

const kwInternalProperties=['Customization Status','Details to Collect','Pet Photo Status','Color Preferences Status','Photo Submission Preference','Photo Submission'];
const kwValidPlacements=new Set(['Front Emblem','Front Hood','Rear Emblem','Rear Trunk','Body Side','Not Sure','Not sure - assistance requested']);
const kwPlacementMessage='Choose a placement or request our help, then save your details before checkout.';
function kwSyncPlacement(input){input.setCustomValidity(kwValidPlacements.has(input.value)?'':kwPlacementMessage);}
document.querySelectorAll('[data-kw-placement]').forEach(kwSyncPlacement);
document.addEventListener('change',event=>{if(event.target.matches('[data-kw-placement]'))kwSyncPlacement(event.target);});
function kwOrderProperties(properties){
 const result={...properties};
 for(const key of kwInternalProperties){if(Object.hasOwn(result,key)){result['_'+key]=result[key];delete result[key];}}
 const hasPhoto=!!result['Pet Photo'];
 if(hasPhoto)delete result['Pet photo'];else result['Pet photo']='Send Later';
 result['_Photo Submission']=hasPhoto?'Uploaded':'Send Later';
 result['_Pet Photo Status']=hasPhoto?'Photo provided':'Pending - Send Later';
 const missing=[];
 if(!hasPhoto)missing.push('Pet photo');
 const hasVehicle=result['Vehicle Information']?.trim()||(result['Vehicle Brand']?.trim()&&result.Model?.trim()&&result.Year?.trim());
 if(!hasVehicle)missing.push('Vehicle information');
 if(!kwValidPlacements.has(result.Position))missing.push('Placement');
 else if(/not sure/i.test(result.Position))missing.push('Placement assistance');
 const colors=Object.entries(result).some(([key,value])=>key.startsWith('Preferred Color - ')&&String(value).trim());
 const custom=String(result['Custom Color']||'').trim();
 const needsCustom=!!result['Custom Color Requested']&&!custom;
 if(needsCustom)missing.push('Custom color details');
 result['_Details to Collect']=missing.join('; ');
 result['_Customization Status']=missing.length?'Pending details - contact customer before production':'Details received - awaiting artwork and fitment review';
 result['_Color Preferences Status']=needsCustom?'Custom color details to confirm':colors||custom?'Provided - confirm in design proof':'Not specified - leave palette to designer';
 result['_Design Preferences Status']=String(result['Design Notes']||'').trim()?'Provided - confirm in design proof':'Not specified (optional)';
 return result;
}
function kwReadFormProperties(form){
 const result={};
 for(const field of form.elements){
  if(!field.name?.startsWith('properties[')||field.disabled||field.matches(':disabled')||(['checkbox','radio'].includes(field.type)&&!field.checked))continue;
  const key=field.name.slice(11,-1);
  if(field.type==='file'){if(field.files?.[0]?.size)result[key]=field.files[0].name;}
  else result[key]=field.value;
 }
 return result;
}
document.querySelectorAll('.kw-form').forEach(kwSyncOptional);
document.addEventListener('formdata',event=>{
 const form=event.target;if(!form.matches('.kw-form')||form.matches('[data-kw-cart-edit]'))return;
 const data=event.formData,properties={};
 for(const [key,value]of data){if(!key.startsWith('properties['))continue;if(value instanceof File){if(value.size)properties[key.slice(11,-1)]=value.name;}else properties[key.slice(11,-1)]=String(value);}
 const order=kwOrderProperties(properties);
 for(const key of kwInternalProperties)data.delete('properties['+key+']');
 for(const [key,value]of Object.entries(order))if(key.startsWith('_'))data.set('properties['+key+']',value);
 if(order['Pet Photo'])data.delete('properties[Pet photo]');else data.set('properties[Pet photo]','Send Later');
});
const kwMissingPlacement=cart=>cart.items.findIndex(item=>item.handle==='custom-pet-portrait-enamel-emblem'&&!kwValidPlacements.has(item.properties?.Position));
function kwMetadataNeedsRefresh(item){
 if(item.handle!=='custom-pet-portrait-enamel-emblem')return false;
 const properties=item.properties||{},order=kwOrderProperties(properties);
 return kwInternalProperties.some(key=>Object.hasOwn(properties,key))||Object.entries(order).some(([key,value])=>key.startsWith('_')&&properties[key]!==value);
}
async function kwNormalizeCart(cart,request){
 let steps=0;
 while(true){
  const item=cart.items.find(kwMetadataNeedsRefresh);if(!item)return cart;
  if(++steps>cart.items.length+2)throw new Error('Personalization update not confirmed');
  cart=await request('cart/change.js',{id:item.key,quantity:item.quantity,properties:kwOrderProperties(item.properties)});
 }
}
async function kwCartRequest(path,payload){
 const response=await fetch((window.Shopify?.routes?.root||'/')+path,{
  method:payload?'POST':'GET',headers:payload?{'Content-Type':'application/json','Accept':'application/json'}:{'Accept':'application/json'},
  body:payload?JSON.stringify(payload):undefined
 });
 if(!response.ok)throw new Error('Cart update not confirmed');
 return response.json();
}
document.addEventListener('submit',async event=>{
 const form=event.target;
 if(!form.matches('[data-kw-cart-edit]'))return;
 event.preventDefault();
 form.querySelectorAll('[data-kw-placement]').forEach(kwSyncPlacement);
 if(!form.reportValidity())return;
 if(document.querySelector('[data-kw-cart-edit][aria-busy=true]'))return;
 const data=new FormData(form),properties={};
 for(const[key,value]of data){if(key.startsWith('properties['))properties[key.slice(11,-1)]=String(value);}
 const button=form.querySelector('button'),status=form.querySelector('[data-kw-cart-edit-status]');
 const original=button.textContent;
 form.setAttribute('aria-busy','true');button.disabled=true;button.textContent=form.dataset.saving;
 const quantities=new FormData(document.querySelector('#kw-cart-update')).getAll('updates[]').map(Number);
 const actions=[...document.querySelectorAll('[form=kw-cart-update]')];
 actions.forEach(control=>control.disabled=true);
 try{
  const cart=await kwCartRequest('cart/update.js',{updates:quantities});
  const item=cart.items.find(line=>line.key===data.get('id'));
  if(!item){location.reload();return;}
  const merged={...item.properties};
  if(form.querySelector('[data-kw-palette]'))for(const key of Object.keys(merged)){if(key.startsWith('Preferred Color - ')||key==='Custom Color'||key==='Custom Color Requested')delete merged[key];}
  const result=await kwCartRequest('cart/change.js',{id:item.key,quantity:item.quantity,properties:kwOrderProperties({...merged,...properties})});
  if(result.item_count!==cart.item_count)throw new Error('Unexpected cart quantity');
  location.reload();
 }catch{
  status.textContent=form.dataset.error;
  form.removeAttribute('aria-busy');button.disabled=false;button.textContent=original;
  actions.forEach(control=>control.disabled=false);
 }
});
document.addEventListener('submit',async event=>{
 const form=event.target;
 if(form.id!=='kw-cart-update')return;
 if(document.querySelector('[data-kw-cart-edit][aria-busy=true]')){event.preventDefault();return;}
 if(event.submitter?.name!=='checkout')return;
 event.preventDefault();
 if(form.dataset.busy)return;
 const data=new FormData(form),button=event.submitter;
 form.dataset.busy='true';button.disabled=true;
 try{
  let cart=await kwCartRequest('cart/update.js',{updates:data.getAll('updates[]').map(Number)});
  const missing=kwMissingPlacement(cart);
  if(missing!==-1){
   const item=[...document.querySelectorAll('[data-kw-cart-key]')].find(element=>element.dataset.kwCartKey===cart.items[missing].key),input=item?.querySelector('[data-kw-placement]');
   if(input){item.querySelector('.kw-cart-editor').open=true;kwSyncPlacement(input);input.focus();input.reportValidity();}
   else location.assign((window.Shopify?.routes?.root||'/')+'cart');
   delete form.dataset.busy;button.disabled=false;return;
  }
  cart=await kwNormalizeCart(cart,kwCartRequest);
  location.assign((window.Shopify?.routes?.root||'/')+'checkout');
 }catch{
  delete form.dataset.busy;button.disabled=false;
  location.reload();
 }
});

(() => {
 const dialog=document.querySelector('[data-kw-drawer]'),copyNode=document.querySelector('[data-kw-drawer-copy]');
 if(!dialog||!copyNode||typeof dialog.showModal!=='function')return;
 let config;
 try{config=JSON.parse(copyNode.textContent);}catch{return;}
 const text=key=>config.text[key]||'',items=dialog.querySelector('[data-kw-drawer-items]'),status=dialog.querySelector('[data-kw-drawer-status]');
 const empty=dialog.querySelector('[data-kw-drawer-empty]'),footer=dialog.querySelector('[data-kw-drawer-footer]'),recovery=dialog.querySelector('[data-kw-drawer-recovery]');
 const checkout=dialog.querySelector('[name=checkout]'),added=dialog.querySelector('[data-kw-drawer-added]');
 let cart=null,busy=false,loaded=false,sequence=0,opener=null,pending=null;
 const root=config.root||'/';
 const money=value=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:cart?.currency||config.currency||'USD'}).format(value/100);
 const node=(tag,className,value)=>{const element=document.createElement(tag);if(className)element.className=className;if(value!==undefined)element.textContent=value;return element;};
 const safeUrl=value=>{if(!value)return null;try{const url=new URL(value,location.origin);return url.protocol==='https:'?url.href:null;}catch{return null;}};
 const controls=disabled=>{dialog.querySelectorAll('[data-kw-drawer-action],input[data-kw-drawer-quantity]').forEach(element=>element.disabled=disabled);checkout.disabled=disabled||!loaded||!cart?.item_count;};
 const setStatus=(message,error=false)=>{status.textContent=message;status.style.color=error?'#f0c3aa':'';};
 const updateBadge=()=>{document.querySelectorAll('.kw-cart-link').forEach(link=>{link.textContent=config.bag+' ('+cart.item_count+')';link.dataset.kwCount=cart.item_count;link.setAttribute('aria-label',config.bag+' ('+cart.item_count+')');});dialog.querySelector('[data-kw-drawer-title]').textContent=text('title')+' ('+cart.item_count+')';};
 const row=(list,label,value,linkUrl)=>{const dt=node('dt','',label),dd=node('dd');if(linkUrl){const link=node('a','',value);link.href=linkUrl;link.target='_blank';link.rel='noopener noreferrer';dd.append(link);}else dd.textContent=value;list.append(dt,dd);};
 const position=value=>({ 'Front Emblem':text('front'),'Front Hood':text('front'),'Rear Emblem':text('rear'),'Rear Trunk':text('rear'),'Steering Wheel Emblem':text('steering'),'Steering Wheel':text('steering'),'Body Side':text('side'),'Not Sure':text('assistance'),'Not sure - assistance requested':text('assistance') }[value]||value||text('pending'));
 function render(next){
  cart=next;loaded=true;items.replaceChildren();updateBadge();
  empty.hidden=!!cart.item_count;footer.hidden=!cart.item_count;
  for(const [index,item]of cart.items.entries()){
   const article=node('article','kw-drawer__item'),product=node('div','kw-drawer__product'),details=node('div');
   const imageUrl=safeUrl(item.featured_image?.url||item.image||'');
   if(imageUrl){const image=node('img','kw-drawer__image');image.src=imageUrl;image.alt=item.featured_image?.alt||item.product_title;image.width=88;image.height=88;image.loading='lazy';product.append(image);}else product.append(node('div','kw-drawer__image'));
   const name=node('a','kw-drawer__name',item.product_title||item.title);name.href=safeUrl(item.url)||config.cartUrl;details.append(name);
   if(item.variant_title&&item.variant_title!=='Default Title')details.append(node('p','kw-drawer__variant',item.variant_title));
   details.append(node('p','kw-drawer__price',money(item.final_price)+' '+text('each')));
   const actions=node('div','kw-drawer__controls'),quantity=node('div','kw-drawer__quantity');
   for(const [action,label,symbol]of [['minus','decrease','−'],['plus','increase','+']]){
    const button=node('button','',symbol);button.type='button';button.dataset.kwDrawerAction=action;button.dataset.key=item.key;button.setAttribute('aria-label',text(label)+': '+(item.product_title||item.title));
    if(action==='minus')quantity.append(button);else{
     const input=node('input');input.type='number';input.min='0';input.step='1';input.value=item.quantity;input.inputMode='numeric';input.dataset.kwDrawerQuantity='';input.dataset.key=item.key;input.setAttribute('aria-label',text('quantity')+': '+(item.product_title||item.title));quantity.append(input,button);
    }
   }
   const remove=node('button','kw-drawer__link',text('remove'));remove.type='button';remove.dataset.kwDrawerAction='remove';remove.dataset.key=item.key;remove.setAttribute('aria-label',text('remove')+': '+(item.product_title||item.title));actions.append(quantity,remove);details.append(actions);product.append(details);article.append(product);
   if(item.handle==='custom-pet-portrait-enamel-emblem'){
    const summary=node('div','kw-drawer__details'),list=node('dl'),properties=item.properties||{};
    summary.append(node('h3','',text('personalization')));
    const vehicle=[properties['Vehicle Brand'],properties.Model,properties.Year].filter(Boolean).join(' · ')||properties['Vehicle Information']||text('pending');
    row(list,text('vehicle'),vehicle);row(list,text('placement'),position(properties.Position));
    const photo=properties['Pet Photo'],photoUrl=photo?safeUrl(photo):null;
    row(list,text('photo'),photoUrl?text('view_photo'):text('photo_later'),photoUrl);
    if(properties['Pet Name'])row(list,text('name'),properties['Pet Name']);
    const colors=Object.entries(properties).filter(([key,value])=>key.startsWith('Preferred Color - ')&&value).map(([,value])=>String(value));
    if(properties['Custom Color'])colors.push(String(properties['Custom Color']));
    else if(properties['Custom Color Requested'])colors.push(text('custom_color'));
    if(colors.length)row(list,text('colors'),colors.join(' · '));
    summary.append(list);
    if(properties['Design Notes']){
     const notes=node('details','kw-drawer__notes');
     notes.append(node('summary','',text('notes')),node('p','',String(properties['Design Notes'])));summary.append(notes);
    }
    if(!photoUrl||!properties.Position||/not sure/i.test(properties.Position))summary.append(node('p','kw-drawer__pending',text('missing')));
    const edit=node('a','kw-drawer__link',text('edit'));edit.href=config.cartUrl+'#kw-cart-item-'+(index+1);summary.append(edit);article.append(summary);
   }
   items.append(article);
  }
  dialog.querySelector('[data-kw-drawer-subtotal]').textContent=money(cart.total_price);
  dialog.querySelector('[data-kw-drawer-savings]').hidden=!(cart.total_discount>0);
  dialog.querySelector('[data-kw-drawer-discount]').textContent='−'+money(cart.total_discount||0);
  dialog.querySelector('[data-kw-drawer-costs]').textContent=(cart.currency||config.currency)+' · '+text('costs');
  recovery.hidden=true;controls(busy);
 }
 async function request(path,payload){
  let response;
  try{response=await fetch(root+path,{method:payload?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:payload?{'Content-Type':'application/json','Accept':'application/json'}:{'Accept':'application/json'},body:payload?JSON.stringify(payload):undefined});}catch{throw new Error(text('error'));}
  let result;try{result=await response.json();}catch{throw new Error(text('error'));}
  if(!response.ok)throw new Error(typeof result.description==='string'?result.description:text('error'));
  return result;
 }
 async function refresh(){
  const ticket=++sequence;loaded=false;controls(true);setStatus(text('loading'));
  try{const result=await request('cart.js');if(ticket!==sequence)return;render(result);setStatus('');}
  catch(error){if(ticket!==sequence)return;setStatus(text('load_error'),true);recovery.hidden=false;controls(true);throw error;}
 }
 async function open(options={}){
  if(!dialog.open){opener=options.trigger||document.activeElement;dialog.showModal();document.documentElement.classList.add('kw-drawer-open');document.querySelectorAll('.kw-cart-link').forEach(link=>link.setAttribute('aria-expanded','true'));dialog.querySelector('[data-kw-drawer-close]').focus({preventScroll:true});}
  added.hidden=!options.added;
  if(pending)await pending;
  await refresh();
 }
 dialog.addEventListener('close',()=>{document.documentElement.classList.remove('kw-drawer-open');document.querySelectorAll('.kw-cart-link').forEach(link=>link.setAttribute('aria-expanded','false'));if(opener?.isConnected)opener.focus({preventScroll:true});});
 dialog.addEventListener('keydown',event=>{
  if(event.key!=='Tab')return;
  const focusable=[...dialog.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')].filter(element=>!element.disabled&&element.tabIndex>=0&&element.getClientRects().length);
  const first=focusable[0],last=focusable.at(-1);if(!first)return;
  if(event.shiftKey&&(document.activeElement===first||!dialog.contains(document.activeElement))){event.preventDefault();last.focus();}
  else if(!event.shiftKey&&(document.activeElement===last||!dialog.contains(document.activeElement))){event.preventDefault();first.focus();}
 });
 dialog.addEventListener('click',event=>{
  if(event.target.closest('[data-kw-drawer-close]')){dialog.close();return;}
  if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();return;}
  if(event.target.closest('[data-kw-drawer-retry]')){refresh().catch(()=>{});return;}
  const control=event.target.closest('[data-kw-drawer-action]');if(!control||busy||!loaded)return;
  const item=cart.items.find(line=>line.key===control.dataset.key);if(!item)return;
  const action=control.dataset.kwDrawerAction,quantity=action==='remove'?0:Math.max(0,item.quantity+(action==='plus'?1:-1));
  change(item.key,quantity,action).catch(()=>{});
 });
 dialog.addEventListener('change',event=>{
  const input=event.target.closest('input[data-kw-drawer-quantity]');if(!input||busy||!loaded)return;
  const quantity=Number(input.value);
  if(!input.value||!Number.isSafeInteger(quantity)||quantity<0){render(cart);setStatus(text('quantity_error'),true);return;}
  change(input.dataset.key,quantity,'quantity').catch(()=>{});
 });
 async function change(key,quantity,action){
  if(busy)return;busy=true;controls(true);setStatus(text('updating'));
  const perform=async()=>{
   try{const result=await request('cart/change.js',{id:key,quantity});render(result);setStatus(quantity===0?text('removed'):text('updated'));if(dialog.open){const next=quantity===0?dialog.querySelector('[data-kw-drawer-close]'):dialog.querySelector('[data-key="'+CSS.escape(key)+'"][data-kw-drawer-action="'+(action==='quantity'?'plus':action)+'"]');next?.focus({preventScroll:true});}}
   catch(error){try{render(await request('cart.js'));}catch{loaded=false;recovery.hidden=false;}setStatus(error.message||text('error'),true);}
   finally{busy=false;controls(!loaded);pending=null;}
  };
  pending=perform();await pending;
 }
 dialog.querySelector('[data-kw-drawer-checkout]').addEventListener('submit',async event=>{
  event.preventDefault();if(busy||!loaded||!cart?.item_count)return;
  busy=true;controls(true);setStatus(text('checkout_loading'));
  try{
   let current=await request('cart.js');
   if(!current.item_count){render(current);busy=false;controls(false);setStatus('');return;}
   if(kwMissingPlacement(current)!==-1){render(current);busy=false;controls(false);setStatus(text('placement_required'),true);recovery.hidden=false;return;}
   current=await kwNormalizeCart(current,request);
   location.assign(root+'checkout');
  }catch{busy=false;setStatus(text('checkout_error'),true);controls(false);recovery.hidden=false;}
 });
 document.addEventListener('click',event=>{
  const trigger=event.target.closest('.kw-cart-link');
  if(!trigger||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||location.pathname.replace(/\/$/,'')===config.cartUrl.replace(/\/$/,''))return;
  event.preventDefault();open({trigger}).catch(()=>{});
 });
 window.kwCartDrawer={open};
})();




